import { connect } from 'react-redux';
import React from 'react';
const CombineHeaderSwitch = React.lazy(() => import('../../components/Layouts/Switch/CombineHeaderSwitch'));

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
  mapDispatchToProps,
)(CombineHeaderSwitch);
